module.exports = __webpack_public_path__ + "static/img/2.9043105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/calendar/2.png
// module id = c428
// module chunks = 1